module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_ciclo_cultivo_4.c9b6866f.jpg";